import Divider from '@mui/material/Divider';
import SmartToyRoundedIcon from '@mui/icons-material/SmartToyRounded';
import ArrowCircleRightRoundedIcon from '@mui/icons-material/ArrowCircleRightRounded';
import PyMuiMenuItem from '../../components/generalComponents/PyMuiMenuItem';
import { AIGradientIcon } from './AIGradientIcon';
import { GenerateAIMenuItem, GenerateAIMenuItemRow } from './styles';

type EditOrGenerateMenuItemProps = {
  enabled: boolean;
  withDivider: boolean;
  onClick: () => void;
  label: string;
};

export const EditOrGenerateMenuItem = ({ enabled, withDivider, onClick, label }: EditOrGenerateMenuItemProps) => {
  if (!enabled) return null;

  return (
    <>
      <PyMuiMenuItem
        testId="edit-or-generate-menu-item"
        onClick={onClick}
        menuItem={
          <GenerateAIMenuItem>
            <GenerateAIMenuItemRow>
              <AIGradientIcon icon={(id) => <SmartToyRoundedIcon fontSize="medium" sx={{ fill: `url(#${id})` }} />} />
              {label}
            </GenerateAIMenuItemRow>
            <ArrowCircleRightRoundedIcon fontSize="medium" />
          </GenerateAIMenuItem>
        }
      />
      {withDivider && <Divider orientation="horizontal" flexItem />}
    </>
  );
};
